import { Col, Row, Card, Table } from "antd";
import React from "react";
import {
  getColumnsWithHighlight,
  renderColumn,
} from "../../AllOrgActivities/helper";
import {
  adjEntryWithCard,
  adjEntryWithoutCard,
  buildColumns,
} from "../../AllOrgActivities/AdjDvrHelper";

export const AdjDriverRate = ({ data, category }) => {
  const renderRegularGroup = (data, accAdjData, adjConfig) => {
    const accAdjAction = accAdjData[0].action;
    const adjConfigAction = adjConfig[0].action;
    const accAdjTitle = adjConfig[0]?.new_value ? "New Entry" : "Old Entry";
    const accAdjType = accAdjAction === "DELETE" ? "REMOVED" : "ADDED";
    const adjConfigType = adjConfigAction === "DELETE" ? "REMOVED" : "ADDED";
    const fmpData =
      adjConfig[0]?.new_value?.fmp ?? adjConfig[0]?.old_value?.fmp;
    const smpData =
      adjConfig[0]?.new_value?.smp ?? adjConfig[0]?.old_value?.smp;
    if (accAdjAction === "UPDATE" || adjConfigAction === "UPDATE") return null;
    return (
      <div className="mb-6">
        <h4
          className="ant-typography ant-typography-md font-medium mb-3"
          style={{ textAlign: "left", fontSize: "16px" }}
        >
          {accAdjTitle}
        </h4>
        <Card
          style={{
            background: "#fff",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
            marginBottom: "16px",
            padding: "2px",
          }}
        >
          {adjEntryWithCard(
            adjConfig,
            "",
            adjConfigType,
            adjConfigAction,
            category
          )}
          {adjEntryWithoutCard(accAdjData, "", accAdjType, accAdjAction)}
          {!_.isEmpty(fmpData) && (
            <>
              <h3
                className="ant-typography ant-typography-md font-medium mb-3"
                style={{ textAlign: "left", fontSize: "16px" }}
              >
                FMP
              </h3>
              <Table
                columns={buildColumns(fmpData).map((col) =>
                  renderColumn(col, adjConfigType)
                )}
                dataSource={fmpData || []}
                pagination={false}
                bordered
                scroll={{ x: "max-content", y: `calc(100vh - 600px)` }}
              />
            </>
          )}
          {!_.isEmpty(smpData) && (
             <>
              <h3
                className="ant-typography ant-typography-md font-medium mb-3"
                style={{ textAlign: "left", fontSize: "16px" }}
              >
                SMP
              </h3>
              <Table
                columns={buildColumns(smpData).map((col) =>
                  renderColumn(col, adjConfigType)
                )}
                dataSource={smpData || []}
                pagination={false}
                bordered
                scroll={{ x: "max-content", y: `calc(100vh - 600px)` }}
              />
            </>
          )}
        </Card>
      </div>
    );
  };

  const renderModifiedGroup = (data, accAdjData, adjConfig, rawData) => {
    const accAdjAction = accAdjData[0].action;
    const adjConfigAction = adjConfig[0].action;
    const accAdjType = accAdjAction === "DELETE" ? "REMOVED" : "ADDED";
    const adjConfigType = adjConfigAction === "DELETE" ? "REMOVED" : "ADDED";
    const fmpOldValues = adjConfig[0]?.old_value?.fmp;
    const fmpNewValues = adjConfig[0]?.new_value?.fmp;
    const smpOldValues = adjConfig[0]?.old_value?.smp;
    const smpNewValues = adjConfig[0]?.new_value?.smp;
    const fmpNewColumns = getColumnsWithHighlight(
      buildColumns(fmpNewValues),
      fmpOldValues,
      fmpNewValues
    );
    const smpNewColumns = getColumnsWithHighlight(
      buildColumns(smpNewValues),
      smpOldValues,
      smpNewValues
    );
    const isOldAdjConfigPresent = !_.isEmpty(adjConfig[0].old_value);
    const isOldFmpPresent = !_.isEmpty(adjConfig[0].old_value?.fmp);
    const isOldSmpPresent = !_.isEmpty(adjConfig[0].old_value?.smp);
    const isNewAdjConfigPresent = !_.isEmpty(adjConfig[0].new_value);
    const isNewFmpPresent = !_.isEmpty(adjConfig[0].new_value?.fmp);
    const isNewSmpPresent = !_.isEmpty(adjConfig[0]?.new_value?.smp);

    if (rawData.action !== "UPDATE") return null;
    return (
      <div className="mb-6">
        <h4
          className="ant-typography ant-typography-md font-medium mb-3"
          style={{ textAlign: "left", fontSize: "16px" }}
        >
          Modified Entries
        </h4>
        <h5
          className="ant-typography ant-typography-sm font-medium mb-2"
          style={{ textAlign: "left", color: "#666", fontWeight: "bold" }}
        >
          Previous Values
        </h5>
        <div className="mb-4">
          <Card
            style={{
              background: "#fff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
              marginBottom: "16px",
              padding: "2px",
            }}
          >
            {isOldAdjConfigPresent &&
              adjEntryWithCard(
                adjConfig,
                "",
                adjConfigType,
                "previous",
                category
              )}
            {adjEntryWithoutCard(accAdjData, "", accAdjType, "previous")}
            {isOldFmpPresent && (
              <>
                <h3
                  className="ant-typography ant-typography-md font-medium mb-3"
                  style={{ textAlign: "left", fontSize: "16px" }}
                >
                  FMP
                </h3>
                <Table
                  columns={buildColumns(fmpOldValues).map((col) =>
                    renderColumn(col, adjConfigType)
                  )}
                  dataSource={fmpOldValues}
                  pagination={false}
                  bordered
                  scroll={{ x: "max-content", y: `calc(100vh - 600px)` }}
                />
              </>
            )}
            {isOldSmpPresent && (
              <>
                <h3
                  className="ant-typography ant-typography-md font-medium mb-3"
                  style={{ textAlign: "left", fontSize: "16px" }}
                >
                  SMP
                </h3>
                <Table
                  columns={buildColumns(smpOldValues).map((col) =>
                    renderColumn(col, adjConfigType)
                  )}
                  dataSource={smpOldValues}
                  pagination={false}
                  bordered
                  scroll={{ x: "max-content", y: `calc(100vh - 600px)` }}
                />
              </>
            )}
          </Card>
        </div>
        <h5
          className="ant-typography ant-typography-sm font-medium mb-2"
          style={{ textAlign: "left", color: "#666", fontWeight: "bold" }}
        >
          Updated Values
        </h5>
        <div>
          <Card
            style={{
              background: "#fff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
              marginBottom: "16px",
              padding: "2px",
            }}
          >
            {isNewAdjConfigPresent &&
              adjEntryWithCard(adjConfig, "", adjConfigType, "new", category)}
            {adjEntryWithoutCard(accAdjData, "", accAdjType, "new")}
            {isNewFmpPresent && (
              <>
                <h3
                  className="ant-typography ant-typography-md font-medium mb-3"
                  style={{ textAlign: "left", fontSize: "16px" }}
                >
                  FMP
                </h3>
                <Table
                  columns={fmpNewColumns}
                  dataSource={fmpNewValues}
                  pagination={false}
                  bordered
                  scroll={{ x: "max-content", y: `calc(100vh - 600px)` }}
                />
              </>
            )}

            {isNewSmpPresent && (
              <>
                <h3
                  className="ant-typography ant-typography-md font-medium mb-3"
                  style={{ textAlign: "left", fontSize: "16px" }}
                >
                  SMP
                </h3>
                <Table
                  columns={smpNewColumns}
                  dataSource={smpNewValues}
                  pagination={false}
                  bordered
                  scroll={{ x: "max-content", y: `calc(100vh - 600px)` }}
                />
              </>
            )}
          </Card>
        </div>
      </div>
    );
  };

  const rawData = data ? data : [];
  const diffData = rawData?.difference[0] ? rawData?.difference[0] : [];
  const accAdjData = !_.isEmpty(diffData) && diffData?.account_adjustments;
  const adjConfig = !_.isEmpty(diffData) && diffData?.adjustment_configuration;

  const renderFuelSurchargeMain = () => {
    return (
      <div className="mt-6">
        <h4
          className="ant-typography ant-typography-md font-medium mb-3"
          style={{ textAlign: "left", fontSize: "18px" }}
        >
          <span style={{ fontSize: "20px", color: "#395484" }}>
            Driver Rate Adjustment
          </span>
          <div className="mt-6">
            {renderRegularGroup(diffData, accAdjData, adjConfig)}
            {renderModifiedGroup(diffData, accAdjData, adjConfig, rawData)}
          </div>
        </h4>
      </div>
    );
  };

  return (
    <Row gutter={[16, 32]}>
      <Col span={24}>{renderFuelSurchargeMain()}</Col>
    </Row>
  );
};
